import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'siths-eid-admin-privileges-view',
  templateUrl: './privileges-view.component.html',
  styleUrls: ['./privileges-view.component.scss']
})
export class PrivilegesViewComponent {
  public active = 0;

  constructor(private router: Router) {
    router.events.subscribe((event: NavigationEnd) => this.handleRouterChanges(event));
  }

  private handleRouterChanges(event: NavigationEnd): void {
    if (!(event instanceof NavigationEnd) || !event.url || event.url.indexOf('privileges/') === -1) {
      return;
    }

    if (event.url.indexOf('privileges/rules') !== -1) {
      this.active = 0;
    } else if (event.url.indexOf('privileges/wsclients') !== -1) {
      this.active = 1;
    }
  }
}
